package com.patronat.top.client.domain.reviews

import com.patronat.top.client.data.reviews.ClientReviewsRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ReviewResponse

data class ToggleClientReviewLikeCommand(
    val reviewId: String,
    val isLiked: Boolean
)

class ToggleClientReviewLikeUseCase(
    private val repository: ClientReviewsRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ToggleClientReviewLikeCommand, DomainResult<ReviewResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: ToggleClientReviewLikeCommand): DomainResult<ReviewResponse> {
        return if (command.isLiked) {
            repository.unlikeReview(command.reviewId)
        } else {
            repository.likeReview(command.reviewId)
        }
    }
}
